import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const HomeBanners = styled(Box)(() => ({
  marginBlockEnd: '1.5rem',

  // Remove margin if there is not any content/banners.
  '&:empty': {
    marginBlockEnd: 0,
  },

  '& > :first-of-type': {
    marginTop: 0,
  },
}));
